var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallCircle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4122 1.14055C19.8207 0.285814 18.216 0.287152 16.5981 1.14055L19.0051 19.5648L21.4122 1.14055Z",
    fill: "#812456"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4548 4.47038C29.4967 2.93124 28.0984 2.12684 26.2618 2.05372L19.1304 19.2179L30.4548 4.47038Z",
    fill: "#812456"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58696 4.47038C8.54499 2.93124 9.94331 2.12684 11.7799 2.05372L18.9113 19.2179L7.58696 4.47038Z",
    fill: "#812456"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4122 37.8594C19.8207 38.7142 18.216 38.7128 16.5981 37.8594L19.0051 19.4352L21.4122 37.8594Z",
    fill: "#812456"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4548 34.5296C29.4967 36.0688 28.0984 36.8732 26.2618 36.9463L19.1304 19.7821L30.4548 34.5296Z",
    fill: "#812456"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.58696 34.5296C8.54499 36.0688 9.94331 36.8732 11.7799 36.9463L18.9113 19.7821L7.58696 34.5296Z",
    fill: "#812456"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.3584 17.1103C38.2146 18.699 38.2132 20.301 37.3584 21.9161L18.9026 19.5132L37.3584 17.1103Z",
    fill: "#812456"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0183 8.08314C35.5601 9.03954 36.3659 10.4355 36.4391 12.2689L19.2456 19.3882L34.0183 8.08314Z",
    fill: "#812456"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0183 30.9169C35.5601 29.9605 36.3659 28.5645 36.4391 26.7311L19.2456 19.6118L34.0183 30.9169Z",
    fill: "#812456"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.641646 17.1103C-0.214553 18.699 -0.213211 20.301 0.641646 21.9161L19.0974 19.5132L0.641646 17.1103Z",
    fill: "#812456"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.98169 8.08314C2.43992 9.03954 1.63415 10.4355 1.5609 12.2689L18.7544 19.3882L3.98169 8.08314Z",
    fill: "#812456"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.98169 30.9169C2.43992 29.9605 1.63415 28.5645 1.5609 26.7311L18.7544 19.6118L3.98169 30.9169Z",
    fill: "#812456"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCircle);
export default __webpack_public_path__ + "static/media/small-circle.5b714b07a392c148c8a1ece60b311572.svg";
export { ForwardRef as ReactComponent };